module.exports = __webpack_public_path__ + "static/media/main-slider-2.07766847.png";